class Constant {
  //  static BASE_URL = "https://uatapi.policicue.com/"
  // static BASE_URL = "https://uatapi.policicue.com/";
  // static BASE_URL = "http://localhost:1051/";
  // static PROD_URL = "https://api.policicue.com/";
  static BASE_URL = "https://api.policicue.com/";
  // static BASE_URL = "http://prod-web-api-env.eba-jchcgvgt.ap-south-1.elasticbeanstalk.com/"
}

export default Constant;

// important resignation process
// {employeeData.hasResigned && (
//   <div className="col-12 mt-3">
//     <div
//       className="accordion"
//       id="resignationAccordion"
//     >
//       <div className="accordion-item">
//         <h2
//           className="accordion-header"
//           id="headingOne"
//         >
//           <button
//             className="accordion-button "
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#collapseOne"
//             aria-expanded="true"
//             aria-controls="collapseOne"
//             style={{ fontWeight: 700 }}
//           >
//             Resignation Details
//           </button>
//         </h2>
//         <div
//           id="collapseOne"
//           className="accordion-collapse collapse show"
//           aria-labelledby="headingOne"
//           data-bs-parent="#resignationAccordion"
//         >
//           <div className="accordion-body row">
//             {/* Resignation Date */}
//             <div className="col-md-4">
//               <label className="form-label icueTextPrimary">
//                 Date of Resignation
//               </label>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="date_of_resignation"
//                 value={
//                   employeeData.date_of_resignation ||
//                   ""
//                 }
//                 onChange={handleInputChange}
//                 disabled={
//                   editableSection !== "Employment"
//                 }
//               />
//             </div>

//             {/* Notice Period */}
//             <div className="col-md-4">
//               <label className="form-label icueTextPrimary">
//                 Notice Period Start Date
//               </label>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="notice_period_start_date"
//                 value={
//                   employeeData.notice_period_start_date ||
//                   ""
//                 }
//                 onChange={handleInputChange}
//                 disabled={
//                   editableSection !== "Employment"
//                 }
//               />
//             </div>
//             <div className="col-md-4">
//               <label className="form-label icueTextPrimary">
//                 Notice Period End Date
//               </label>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="notice_period_end_date"
//                 value={
//                   employeeData.notice_period_end_date ||
//                   ""
//                 }
//                 onChange={handleInputChange}
//                 disabled={
//                   editableSection !== "Employment"
//                 }
//               />
//             </div>
//             <div className="col-md-4 py-4">
//               <label className="form-label icueTextPrimary">
//                 Resignation Type
//               </label>
//               <select
//                 className="form-select"
//                 name="resignation_type"
//                 value={
//                   employeeData.resignation_type ||
//                   ""
//                 }
//                 onChange={handleInputChange}
//                 disabled={
//                   editableSection !== "Employment"
//                 }
//               >
//                 <option value="">Select</option>
//                 <option value="Voluntary">
//                   Voluntary
//                 </option>

//                 <option value="Termination">
//                   Termination
//                 </option>
//                 <option value="Retirement">
//                   Retirement
//                 </option>
//                 <option value="Other">Other</option>
//               </select>
//             </div>
//             {/* FNF Status */}
//             <div className="col-md-4 py-4">
//               <label className="form-label icueTextPrimary">
//                 F&F Status
//               </label>
//               <select
//                 className="form-select"
//                 name="f_and_f_status"
//                 value={
//                   employeeData.f_and_f_status || ""
//                 }
//                 onChange={handleInputChange}
//                 disabled={
//                   editableSection !== "Employment"
//                 }
//               >
//                 <option value="">Select</option>
//                 <option value="Pending">
//                   Pending
//                 </option>
//                 <option value="Completed">
//                   Completed
//                 </option>
//               </select>
//             </div>
//             {/* upload Releiving letter */}
//             <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
//               <label
//                 htmlFor="icueGenFormTypeInsurance"
//                 className="form-label icueTextPrimary icueGenInfoLabel mt-3"
//               >
//                 Upload Relieving Letter
//               </label>

//               <div className="pt-2">
//                 {employeeData.relieving_letter ? (
//                   <div className="img-preview">
//                     {/* Preview Image or PDF */}
//                     {employeeData.relieving_letter.endsWith(
//                       ".pdf"
//                     ) ? (
//                       <iframe
//                         // src={employeeData.Relieving}
//                         title="Relieving Preview"
//                         width="100%"
//                         height="190px"
//                         style={{
//                           border: "1px solid #ccc",
//                           borderRadius: "4px",
//                         }}
//                       ></iframe>
//                     ) : (
//                       <img
//                         src={
//                           employeeData.relieving_letter
//                         }
//                         alt="Relieving Preview"
//                         style={{
//                           maxHeight: "190px",
//                           borderRadius: "4px",
//                         }}
//                       />
//                     )}

//                     {/* Delete icon (only if editable) */}
//                     {/* {!isDisabled && (
//                 <img
//                   onClick={() =>
//                     deleteFile("pay_slip", index)
//                   }
//                   className="clear"
//                   src={X}
//                   alt="clear-preview"
//                 />
//               )} */}
//                   </div>
//                 ) : (
//                   <div className="img-preview">
//                     <img
//                       src={ImagePlaceholder}
//                       alt="placeholder"
//                       style={{ height: "190px" }}
//                     />
//                   </div>
//                 )}
//               </div>
//             </div>
//             {/* Resignation Reason */}
//             <div className="col-12 mt-3">
//               <label className="form-label icueTextPrimary">
//                 Reason for Resignation
//               </label>
//               <textarea
//                 className="form-control"
//                 rows={3}
//                 name="resignation_reason"
//                 value={
//                   employeeData.resignation_reason ||
//                   ""
//                 }
//                 onChange={handleInputChange}
//                 disabled={
//                   editableSection !== "Employment"
//                 }
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// )}
